import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DriverLayout from '../../components/DriverLayout/DriverLayout';
import { authFetch } from '../../lib/directus';
import styles from './DriverTrips.module.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.driftwoodagri.com';

const TABS = ['All', 'Transport sourced', 'Pending dispatch', 'Pickup completed', 'In transit', 'Delivered'];

const STATUS_LABEL = {
  transport_sourced: 'Transport sourced',
  pending_dispatch: 'Pending dispatch',
  pickup_completed:  'Pickup completed',
  in_transit:        'In transit',
  delivered:         'Delivered',
};

function mapTrip(t) {
  const batch = t.order?.batch || {};
  return {
    id:       t.id,
    loadRecordId: t.id,
    orderId:  t.order?.id || null,
    loadId:   t.load_id ? `#${t.load_id}` : `#${String(t.id).slice(0, 8).toUpperCase()}`,
    pickup:   t.pickup_location || '-',
    delivery: t.delivery_location || '-',
    cargo:    batch.commodity ? `${batch.commodity}${batch.grade ? ` (${batch.grade})` : ''}` : '-',
    quantity: batch.quantity ? `${batch.quantity} MT` : '-',
    truck:    t.assigned_truck?.truck_id || '-',
    status:   STATUS_LABEL[t.order?.fulfillment_status] || 'In transit',
    rawStatus: t.order?.fulfillment_status,
    date:     t.date_updated
                ? new Date(t.date_updated).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })
                : '-',
  };
}

export default function DriverTrips() {
  const navigate  = useNavigate();
  const [trips, setTrips]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [activeTab, setActiveTab] = useState('All');

  useEffect(() => {
    authFetch(
      `${API_URL}/items/loads?fields=id,load_id,pickup_location,delivery_location,date_updated,order.id,order.fulfillment_status,order.batch.commodity,order.batch.grade,order.batch.quantity,assigned_truck.truck_id&filter[assigned_driver][user][_eq]=$CURRENT_USER&filter[order][fulfillment_status][_in]=transport_sourced,pending_dispatch,pickup_completed,in_transit,delivered&sort=-date_updated`
    )
      .then(async (res) => {
        const json = await res.json();
        if (!res.ok) throw new Error(json?.errors?.[0]?.message || 'Failed to fetch loads');
        return json;
      })
      .then(json => { setTrips((json.data || []).map(mapTrip)); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const filtered = activeTab === 'All' ? trips : trips.filter(t => t.status === activeTab);

  return (
    <DriverLayout>
      <div className={styles.page}>
        <h1 className={styles.pageTitle}>My trips</h1>

        <div className={styles.tabsRow}>
          {TABS.map(tab => (
            <button
              key={tab}
              className={`${styles.tab} ${activeTab === tab ? styles.tabActive : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {loading && <p className={styles.loadingText}>Loading...</p>}

        {!loading && filtered.length === 0 && (
          <p className={styles.loadingText}>No trips found.</p>
        )}

        {!loading && filtered.length > 0 && (
          <div className={styles.cardsGrid}>
            {filtered.map(trip => (
              <div
                key={trip.id}
                className={styles.tripCard}
                onClick={() => navigate(`/trips/${trip.id}`, { state: { trip } })}
              >
                <div className={styles.cardHeader}>
                  <span className={styles.loadId}>{trip.loadId}</span>
                  <span className={trip.status === 'Delivered' ? styles.badgeDelivered : styles.badgeInTransit}>
                    {trip.status}
                  </span>
                </div>
                <div className={styles.cardBody}>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Route</span>
                    <span className={styles.infoValue}>{trip.pickup} → {trip.delivery}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Cargo</span>
                    <span className={styles.infoValue}>{trip.cargo}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Truck</span>
                    <span className={styles.infoValue}>{trip.truck}</span>
                  </div>
                  <div className={styles.infoRow}>
                    <span className={styles.infoLabel}>Date</span>
                    <span className={styles.infoValue}>{trip.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </DriverLayout>
  );
}
